import { api } from '@/config/api';
export interface AiProviderKey {
  _id: string; provider: 'openai' | 'claude' | 'qwen' | 'gemini' | 'mistral' | 'elevenlabs'; defaultModel: string; isDefault: boolean; isActive: boolean;
  keyMasked: string | null; source: 'saved' | 'db' | 'env' | 'missing'; status: 'missing' | 'disabled' | 'configured' | 'connected' | 'error'; lastTestedAt?: string; lastTestResult?: 'ok' | 'failed';
}
export const aiProvidersService = {
  list: async (): Promise<AiProviderKey[]> => (await api.get('/super_admin/ai-providers')).data,
  upsert: async (p: { provider: string; apiKey: string; defaultModel: string; isDefault?: boolean; isActive?: boolean }) =>
    (await api.put('/super_admin/ai-providers', p)).data,
  setEnabled: async (provider: string, enabled: boolean) => (await api.patch(`/super_admin/ai-providers/${provider}/enabled`, { enabled })).data,
  remove: async (id: string) => { await api.delete(`/super_admin/ai-providers/${id}`); },
  test: async (provider: string, apiKey: string, model: string) =>
    (await api.post('/super_admin/ai-providers/test', { provider, apiKey, model })).data as { ok: true } | { ok: false; error: string },
  testStored: async (id: string) => (await api.post(`/super_admin/ai-providers/${id}/test`)).data as { ok: true } | { ok: false; error: string },
};
